import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lastTransactionId: '',
};

const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        setLastTransactionId: (state, action) => {
            console.log('setLastTransactionId reducer called with:', action.payload);
            state.lastTransactionId = action.payload;
        }
    }
});

export const generalActions = generalSlice.actions;
export default generalSlice.reducer;